import { render, staticRenderFns } from "./DeepCrawl.vue?vue&type=template&id=52beda5c&"
import script from "./DeepCrawl.vue?vue&type=script&lang=js&"
export * from "./DeepCrawl.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/cjzhi98/chatwoot-saas/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('52beda5c')) {
      api.createRecord('52beda5c', component.options)
    } else {
      api.reload('52beda5c', component.options)
    }
    module.hot.accept("./DeepCrawl.vue?vue&type=template&id=52beda5c&", function () {
      api.rerender('52beda5c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app/javascript/dashboard/routes/dashboard/knowledge/components/DeepCrawl.vue"
export default component.exports